import { render, staticRenderFns } from "./electronic-invoice.vue?vue&type=template&id=4d0ae118"
import script from "./electronic-invoice.vue?vue&type=script&lang=js"
export * from "./electronic-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports